import type { FeedbackScreen } from '../index.js'

/**
 * A snapshot of the screen the person is looking at, so a developer can
 * find it again: the path and title, the browser facts that change how
 * it renders, and whatever the app knows about what is open on it. Only
 * values that are already on the page or in the address bar are read;
 * nothing is sent unless the person chooses to include it.
 */
export function captureScreen(area: FeedbackScreen['area'], details: Readonly<Record<string, string | null | undefined>>): FeedbackScreen {
  const known = Object.fromEntries(Object.entries(details).filter((entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1] !== ''))
  return {
    area,
    path: `${window.location.pathname}${window.location.search}`,
    title: document.title,
    url: window.location.href,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    userAgent: navigator.userAgent,
    capturedAt: new Date().toISOString(),
    ...(Object.keys(known).length > 0 ? { details: known } : {}),
  }
}
